import { useNavigate } from '@tanstack/react-router'
import { AppFooter } from '@/components/molecules/app-footer'
import { GtmHalftoneBackground } from '@/features/gtm/components/gtm-halftone-background'
import { GtmHero } from '@/features/gtm/components/gtm-hero'
import { GtmLandingHeader } from '@/features/gtm/components/gtm-landing-header'
import {
  GtmFinalCta,
  GtmOwnIndex,
  GtmTestimonials,
  GtmTrust,
} from '@/features/gtm/components/gtm-landing-sections'
import { GtmCampaignFlow } from '@/features/gtm/components/gtm-campaign-flow'
import { GtmResultPreview } from '@/features/gtm/components/gtm-landing-preview'
import { useGtmTheme } from '@/features/gtm/components/use-gtm-theme'
import { useGtmDemo } from '@/features/gtm/domain/use-gtm-demo'
import { useCurrentLang } from '@/shared/i18n/use-current-lang'

/** Laplace x GTM start page: paste a site URL, see leads before signing up. */
function GtmLandingPage() {
  const lang = useCurrentLang()
  const navigate = useNavigate()
  const demo = useGtmDemo({
    onCreated: (runId) =>
      void navigate({
        to: '/$lang/gtm/$runId',
        params: { lang, runId },
        search: { checkout: undefined },
      }),
  })

  useGtmTheme()

  return (
    // Laplace GTM theme: newsprint page over a halftone screen with a comet.
    <div className="theme-gtm relative isolate min-h-screen overflow-hidden bg-background text-foreground">
      <GtmHalftoneBackground />
      <div className="relative z-10 mx-auto max-w-6xl px-4 pt-4 sm:px-8 sm:pt-6 lg:px-12">
        <GtmLandingHeader />
        <main>
          <GtmHero demo={demo} />
          <GtmResultPreview />
          <GtmCampaignFlow />
          <GtmOwnIndex />
          <GtmTrust />
          <GtmTestimonials />
          <GtmFinalCta />
        </main>
      </div>
      <AppFooter className="relative z-10" hideTelegram />
    </div>
  )
}

export default GtmLandingPage
